module.exports = __webpack_public_path__ + "static/media/marisa.b93b4cbc.jpeg";